import _ from 'lodash';
import React, { FunctionComponent } from 'react';
import * as Styled from './styled';
import palette from '@mlc/mlc-palette';
import MenuItem from './MenuItem/MenuItem';
import logo from './mlc-logo.png';
import navBarTestIds from './NavigationMenu.elements';
import { NavTreeItem } from '../../../logic/domains/navigationTree.domain';
import { Card, Col, Grid, Row } from '@mlc/web-ui-toolkit';

type NavigationMenuProps = {
	menuItems?: NavTreeItem[];
	licenseeMenu?: NavTreeItem;
	homeLogoLink: string;
};

const MEDIUM_SCREEN_SIZE_WIDTH = 991;

const NavigationMenu: FunctionComponent<NavigationMenuProps> = ({
	menuItems,
	licenseeMenu,
	homeLogoLink,
}) => {
	return (
		<Styled.NavCard
			paddingTop={2}
			paddingBottom={2}
			display="flex"
			alignItems="center"
			data-analytics-group="header"
		>
			<Grid>
				<Row>
					<Styled.NavCol
						col={true}
						data-id={navBarTestIds.navigationBar}
						noGutter
					>
						<Styled.LogoLink
							id="mlcLogo"
							href={homeLogoLink}
							data-id={navBarTestIds.navMenuHomeLogoContainer}
						>
							<Styled.Logo src={logo} alt="mlc-logo" />
						</Styled.LogoLink>
						<Styled.NavLinksContainer>
							<Styled.Ul>
								{_.map(menuItems, (item: NavTreeItem) => (
									<MenuItem
										key={_.snakeCase(item.title)}
										relativePath={item.path}
										absolutePath={item.url}
										title={item.title}
										subpages={item.subpages}
									/>
								))}
								{licenseeMenu ? (
									<Styled.LicenseeMenuItem
										title="My licensee"
										relativePath="#"
										subpages={licenseeMenu.subpages}
										activeStyle={{
											backgroundColor: palette.mlcBlack,
											color: palette.mlcWhite,
										}}
										showSubMenuAlignedRight={() => {
											return window.innerWidth > MEDIUM_SCREEN_SIZE_WIDTH;
										}}
									/>
								) : null}
							</Styled.Ul>
						</Styled.NavLinksContainer>
					</Styled.NavCol>
				</Row>
			</Grid>
		</Styled.NavCard>
	);
};

export default NavigationMenu;
